import React from 'react';
import Alert from '../components/Alert';

const { id: module_id } = module;

const defaultMessage = `${module_id}.default.error.message`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.hasError) {
      return false;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      // reset Error state only if state previously was showing error
      this.setState((state) => {
        return { ...state, hasError: false };
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <Alert
            type="error"
            isHtml={this.props.isHtml}
            message={this.props.errorMessage || defaultMessage}
          />
        </div>
      );
    } else {
      return <div>{this.props.children}</div>;
    }
  }
}

export default ErrorBoundary;
